<!-- Here we display the answers -->
<div class="main-container background-img">
  <div class="container pl-md-0">
    <div class="row pt-3">
      <div class="col-md-12">
        <img src="../../assets/ipc-logo-rev.png" class="ipc-logo" alt="ipc logo">
        <span>
          <a (click)="onPrintReport()" class="float-right btn btn-outline-primary btn-spacing connect-btn">Advisor:
            Next</a>
        </span>
      </div>
    </div>
  </div>
  <div class="container mb-5 pl-md-0 mt-5 mt-md-5 pt-0 pt-md-5">
    <div class="row">
      <div class="col-md-8 col-xl-8">
        <h2>Thank you for completing the questionnaire. </h2>

        <h2>Estate planning is all about making decisions that will help you transfer your estate assets to
          beneficiaries in a way that meets your objectives and satisfies your wishes. Your responses to this
          questionnaire will provide us with a better understanding of your needs so we can work towards meeting your
          estate planning goals.</h2>

        <!-- Button to Open the Modal 
        <a class="" data-toggle="modal" data-target="#myModal"><p>Add Comments</p>
        </a>
        <div class="modal fade" id="myModal">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">

              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>

              <div class="modal-body">
                <textarea name="message" [(ngModel)]="comments" placeholder="Add comments here" rows="10" cols="80" style="border: none; width: 100%;"></textarea>
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-outline-primary" data-dismiss="modal">Close</button>
              </div>

            </div>
          </div>
        </div>-->

        <p class="contact-buttons">
          <span>
            <!-- A button allows us to start the quiz over, and a click event resets the user answers -->
            <a class="btn btn-outline-primary btn-restart mr-3"
              (click)="clear()">Restart the
              assessment</a>
            <!-- <button class="btn btn-outline-primary" [routerLink]="['/home/question/11']">Back</button> -->
          </span>
        </p>
        <!--<p>
          <a class="p-0 answers-dropdown" data-toggle="collapse" data-target="#navbarTogglerDemo03"
            aria-controls="navbarTogglerDemo03" aria-expanded="false" aria-label="Toggle navigation" (click)="toggle()">
            View all the answers <span class="toogle-icon">{{toogleIcon}}</span>
          </a>
        </p>

        <div class="collapse justify-content-end navbar-collapse" [ngClass]="{ 'show': isShown }"
          id="navbarTogglerDemo03">
          <ng-container *ngFor="let answer of quiz.answers; let i = index;">
            <p><strong>Question :</strong> {{ answer.question }}</p><br>
            <p><strong>Answer :</strong> {{ quiz.answers }}</p><br>
            <p></p>
          </ng-container>
        </div>-->

      </div>
    </div>
  </div>
</div>
<footer class="footer">
  <div class="container pl-md-0">
    <div class="row">
      <div class="col-md-12 top-footer-text mt-4 text-center">
        <!-- <h3 class="font-weight-bold">HEAD OFFICE</h3>
        <p>5015 Spectrum Way. Mississauga, ON. Canada</p>
        <p>Phone: <a class="top-footer-text" href="tel:905-212-9799">905-212-9799</a></p>
        <hr class="footer-hr"> -->
        <p class="bottom-footer-text">© 2020 <a class="bottom-footer-text" href="https://www.ipcc.ca"
            target="_blank">Investment Planning
            Counsel</a></p>
      </div>
    </div>
  </div>
</footer>